module.exports = __webpack_public_path__ + "static/media/add.6dc7527c.svg";